(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const cartNoteUrl = document.querySelector('.drawer__footer .cart-note-url')

    // 监听smile是否已经加载，如果加载了就给自定义按钮添加点击事件
    document.addEventListener('smile-ui-loaded', () => {
      cartNoteUrl.classList.remove('disable')
      // SmileUI has loaded
      cartNoteUrl.addEventListener('click', ()=> {
        if (window.SmileUI) {
          SmileUI.openPanel();
        } else {
          console.warn('SmileUI 未加载');
        }
      })
    })
  })
  } catch(e) { console.error(e); }
})();

})();
